// @ts-nocheck
import { request as requester } from 'sonata-react-components';

import type { GeoDictionary } from 'mercator-cartography-api-client/lib/interfaces/geoDictionary.types';

export async function getCoverageReportVariables(
  country: string,
  requestToken?: Record<string, unknown>
): Promise<Record<string, any>> {
  const baseUrl = `${taptap.config.backendUrlBase}coverageInsightsReport/variables`;

  return requester.makeRequest(
    baseUrl,
    {
      method: 'GET',
      params: {
        country
      }
    },
    requestToken
  );
}

export async function getCartographyDictionary(
  countries: string[],
  requestToken?: Record<string, unknown>
): Promise<GeoDictionary[]> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}cartography/dictionary`,
    {
      params: {
        countries,
        inEvents: true
      }
    },
    requestToken
  );
}

export async function generateCoverageStudyReport(
  payload: Record<string, any>,
  requestToken?: Record<string, unknown>
): Promise<Record<string, any>> {
  const baseUrl = `${taptap.config.backendUrlBase}coverageInsightsReport`;

  return requester.makeRequest(
    baseUrl,
    {
      data: payload,
      method: 'POST'
    },
    requestToken
  );
}

export async function getCoverageStudyReportURL(id: string, requestToken?: Record<string, unknown>): Promise<string> {
  const baseUrl = `${taptap.config.backendUrlBase}coverageInsightsReport/${id}/reportUrl`;

  return requester.makeRequest(
    baseUrl,
    {
      method: 'GET'
    },
    requestToken
  );
}

export async function getLastCoverageReport(
  userId: string,
  campaignId: string,
  requestToken?: Record<string, unknown>
): Promise<Record<string, any>> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}coverageInsightsReport/last`,
    {
      data: {
        campaignIds: [campaignId],
        userId
      },
      method: 'POST',
      params: {
        source: 'reporting'
      }
    },
    requestToken
  );
}
